import {
  DEVICE_HIBERNATING,
  DEVICE_OFFLINE,
  DEVICE_ONLINE,
  DEVICE_NEEDS_UPGRADE,
  DEVICE_DOWNGRADES,
} from "constant/device-status";
import { VIEW } from "view/views";

const SIDEBAR_DEVICES = {
  path: "/devices",
  key: "devices",
  icon: "desktop",
  label: "Devices",
  children: [
    {
      badges: [
        {
          alwaysShow: true,
          color: DEVICE_ONLINE.color,
          key: "badge-online",
          title: "Online Devices",
        },
        {
          alwaysShow: true,
          color: DEVICE_HIBERNATING.color,
          key: "badge-hibernating",
          title: "Hibernating Devices",
        },
        {
          alwaysShow: true,
          color: DEVICE_OFFLINE.color,
          key: "badge-offline",
          title: "Offline Devices",
        },
      ],
      exactMatch: true,
      icon: "list",
      label: "List",
      path: "/devices",
      rerenderView: true,
    },
    {
      icon: "plus-square",
      label: "New",
      path: `/devices/${VIEW.CREATE}`,
    },
    {
      icon: "files-o",
      label: "Bulk Register",
      path: "/devices/bulk-registration",
    },
    {
      icon: "pencil",
      label: "Bulk Edit",
      path: "/devices/bulk-edit",
    },
    {
      badges: [
        {
          color: DEVICE_NEEDS_UPGRADE.color,
          key: "badge-upgrade-software",
          title: "Needs Software Upgrade",
        },
      ],
      exactMatch: true,
      icon: "level-up",
      label: "Up/Downgrade Players",
      path: "/devices/upgrade",
    },
    {
      badges: [
        {
          color: DEVICE_NEEDS_UPGRADE.color,
          key: "badge-upgrade-firmware",
          title: "Needs Firmware Upgrade",
        },
      ],
      icon: "level-up",
      label: "Upgrade Firmware",
      path: "/devices/upgrade/firmware",
    },
    {
      icon: "times",
      label: "Delete",
      path: "/devices/delete",
    },
  ],
};

const SIDEBAR_STRATEGIES = {
  path: "/v2/strategies",
  key: "strategies_v2",
  icon: "object-group",
  label: "Strategies",
  children: [
    {
      exactMatch: true,
      icon: "list",
      label: "List",
      path: "/v2/strategies",
    },
    {
      icon: "plus-square",
      label: "New",
      path: `/v2/strategies/${VIEW.CREATE}`,
    },
    {
      icon: "th-large",
      label: "Media Library",
      path: "/v2/strategies/media-library",
    },
    {
      exactMatch: true,
      icon: "play",
      label: "Deploy",
      path: "/v2/strategies/deploy",
    },
    {
      exactMatch: true,
      icon: "calendar",
      label: "Scheduled Deployments",
      path: "/v2/strategies/scheduled",
    },
    {
      exactMatch: true,
      icon: "history",
      label: "Past Deployments",
      path: "/v2/strategies/deployments",
    },
  ],
};

const SIDEBAR_APPS = {
  path: "/applications",
  key: "applications",
  icon: "cogs",
  label: "Applications",
  children: [
    {
      exactMatch: true,
      icon: "list",
      label: "Installed Apps",
      path: "/applications",
    },
    {
      icon: "plus-square",
      label: "Upload",
      path: "/applications/upload",
    },
    {
      icon: "shopping-cart",
      label: "App Store",
      path: "/applications/store",
    },
  ],
};

const SIDEBAR_NETWORKS = {
  path: "/networks",
  key: "networks",
  icon: "sitemap",
  label: "Networks",
  children: [
    {
      exactMatch: true,
      icon: "list",
      label: "List",
      path: "/networks",
    },
    {
      icon: "plus-square",
      label: "New",
      path: `/networks/${VIEW.CREATE}`,
    },
  ],
};

const SIDEBAR_DIAGNOSTICS = {
  path: "/diagnostics",
  key: "diagnostics",
  icon: "heartbeat",
  label: "Monitoring",
  children: [
    {
      exactMatch: true,
      icon: "bullhorn",
      label: "Events",
      path: "/diagnostics",
    },
    {
      icon: "warning",
      label: "Triggered Alerts",
      path: "/diagnostics/incidents",
    },
    {
      exactMatch: true,
      icon: "bell",
      label: "Alerts",
      path: "/diagnostics/alerts",
    },
    {
      exactMatch: true,
      icon: "plus-square",
      label: "New Alert",
      path: `/diagnostics/alerts/${VIEW.CREATE}`,
    },
  ],
};

const SIDEBAR_REPORTS = {
  path: "/reports",
  key: "reports",
  icon: "file-text-o",
  label: "Reports",
  children: [
    {
      exactMatch: true,
      icon: "arrow-circle-up",
      label: "Uptime",
      path: "/reports",
      additionalPaths: [{ path: "/reports/uptime" }],
    },
    {
      icon: "picture-o",
      label: "Ad Delivery",
      path: "/reports/ad-delivery",
    },
  ],
};

const SIDEBAR_USERS = {
  path: "/users",
  key: "users",
  icon: "users",
  label: "Users",
  children: [
    {
      exactMatch: true,
      icon: "list",
      label: "List",
      path: "/users",
    },
    {
      icon: "plus-square",
      label: "New",
      path: `/users/${VIEW.CREATE}`,
    },
  ],
};

const SIDEBAR_ITEMS = [
  SIDEBAR_DEVICES,
  SIDEBAR_STRATEGIES,
  SIDEBAR_APPS,
  SIDEBAR_NETWORKS,
  SIDEBAR_DIAGNOSTICS,
  SIDEBAR_REPORTS,
  SIDEBAR_USERS,
];

export { SIDEBAR_ITEMS };
